<div  class="hr-detail-bar"><hr></div>
<div class="container">
    <div class="col-12 text-center">
        <H3>ESTIMATE / QUOTATION</H3>
    </div>
    <BR>
    <div class="row">

        <div class="col-md-2">
            <img src="../../../assets/company logo/LOGO.png" alt=""
                class="img-fluid">
        </div>
        <div class="col-md-3">
            <h5>KRM INFO TECH</h5>
            <!-- <h6>Office Number :<small> 04371 220770</small></h6> -->
            <h6>Business Number :<small> 8524865763</small></h6>
            <small>5/13 - Manivilan 5<sup>th</sup> Street, KK - Nagar,<br> Aranthangi - 614616, Pudukkottai Dt.
                <br>mohamedhasim.official@gmail.com</small>

        </div>

        <div class="col-md-7 text-right">
            <strong>SERIAL NUMBER</strong>
            <p>{{ serialNumber }}</p>
            <strong>DATE</strong>
            <!-- <p id="today_date"></p> -->
            <p>{{ curDate | date:'dd/MM/yyyy HH:mm:ss'}}</p>


        </div>

    </div>
    <hr>
    
    <strong>TO</strong>
    <h5>Name : {{customerValues.customerName}} </h5>
    <h6>Phone Number : <small>{{customerValues.customerPhone}}</small></h6>
    <small> Place: {{customerValues.customerPlace}} </small>

</div>
